import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react"
import { ChevronDownIcon } from "@heroicons/react/24/outline"
import { useTranslation } from "react-i18next"

const QUESTIONS = ["whyVisualMind", "howToGetAccess", "howToCancel"]

export default function PaywallFaq() {
  const { t } = useTranslation()

  return (
    <div className="space-y-4">
      <h2 className="vm-heading">{t("components.faq.heading")}</h2>

      <div className="vm-card divide-y divide-vm-line">
        {QUESTIONS.map((question) => (
          <Disclosure key={question}>
            <div className="px-4">
              <DisclosureButton className="group flex w-full items-center justify-between gap-3 py-4 text-left text-[15px] font-semibold text-vm-ink">
                {t(`components.faq.${question}Title`)}
                <ChevronDownIcon className="h-5 w-5 shrink-0 text-vm-muted transition-transform duration-200 group-data-[open]:rotate-180" />
              </DisclosureButton>
              <DisclosurePanel
                className="origin-top pb-4 text-sm leading-relaxed text-vm-muted transition duration-200 ease-out data-[closed]:-translate-y-2 data-[closed]:opacity-0"
                transition
              >
                {t(`components.faq.${question}Text`)}
              </DisclosurePanel>
            </div>
          </Disclosure>
        ))}
      </div>
    </div>
  )
}
